"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Area = void 0;
const AreaTypes_1 = require("../../types/AreaTypes");
const Geofence_1 = require("./Geofence");
const debug = process.env.REACT_APP_DEBUG && false;
const typeName = 'Area';
const hideCoverageMetric = (a) => {
    if (a.subType !== 'Coverage') {
        return { hidden: true };
    }
    return { hidden: false };
};
class Area extends Geofence_1.Geofence {
    constructor(ob) {
        super({ ...ob, type: ob.type ?? typeName });
        this.color = ob.color;
        this.opacity = ob.opacity;
        this.lastPoint = ob.lastPoint;
        this.subType = ob.subType;
        this.theme = ob.theme;
    }
    getUserAttributes() {
        return {
            name: { type: 'String', editable: true, required: true, label: 'Name', name: 'name', description: 'identification', validation: undefined },
            description: { type: 'String', editable: true, label: 'Description', description: 'description' },
            subType: { type: 'Enum', editable: true, required: true, label: 'Subtype', description: 'subtype', enumKv: AreaTypes_1.AreaSubTypeEnum },
            ...AreaTypes_1.CoverageKPIUserAttributes,
        };
    }
}
exports.Area = Area;
